export default __webpack_public_path__ + "static/media/default-loader.d5458083.svg";